module.exports = __webpack_public_path__ + "static/instantaneo-1773b5f40f199aadd0580c32790a27e9.svg";